import { pull as pull$1 } from '../../array/pull.mjs';

function pull(arr, ...valuesToRemove) {
    return pull$1(arr, valuesToRemove);
}

export { pull };
